module.exports = __webpack_public_path__ + "static/media/improved-customer-experience.e67e1599.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/improved-customer-experience.png
// module id = 1181
// module chunks = 0